export const fontSize = {
  base: '20px',

  lg: '24px',
  md: '20px',
  sm: '16px',
  xs: '14px',
};
